import {cloneDeep} from 'lodash';
import {Component, OnInit} from '@angular/core';
import {MealPlanClass} from '../../class/meal-plan/meal-plan.class';
import {IPatientPlan, MealPlanActions, MealPlanState} from '../../models/meal-plans';
import {IUser} from '../../models/auth';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {StorageService} from '../../services/storage/storage.service';
import {Store} from '@ngxs/store';
import {MealPlansService} from '../../services/meal-plans/meal-plans.service';
import {OptionsMealPlanEnum} from '../../enums/meal-plan';
import {Loader} from '../../models/loader/loader.redux';
import {Logger} from '../../class/helper/logger.class';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-consultation-orientation',
  templateUrl: './consultation-orientation.component.html',
  styleUrls: ['./consultation-orientation.component.scss']
})
export class ConsultationOrientationComponent implements OnInit {
  mealPlanClass: MealPlanClass;
  patientPlan: IPatientPlan;
  params: Params;
  appointmentId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private mealPlanService: MealPlansService,
    private router: Router,
    private storageService: StorageService,
    private store: Store,
    private utilitiesService: UtilitiesService,
  ) { }

  ngOnInit(): void {
    this.initValues();
    this.initValuesHttp().then();
  }

  private initValues(): void {
    this.params = this.utilitiesService.getAllParams(this.activatedRoute);
    this.appointmentId = this.activatedRoute.snapshot.queryParams.appointmentId;
  }

  private async initValuesHttp(): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Cargando información ...'))));
      await this.getMealPlanToPatientByAppointmentId();
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  /**
   * obtener el meal plan por appointment id
   */
  async getMealPlanToPatientByAppointmentId(): Promise<void> {
    const userLogged: IUser = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
    const [expert] = userLogged?.experts;
    await firstValueFrom(this.store.dispatch(
      new MealPlanActions.GetLastMealPlanOfPatient(
        this.params.clinicId,
        this.params.patientId,
        expert?._id,
        this.appointmentId
      )
    ));
    this.patientPlan = cloneDeep(await firstValueFrom((this.store.selectOnce(MealPlanState.getActiveMealPlanOfPatient))));
    if (!this.patientPlan?.mealPlan) return;
    this.mealPlanClass = new MealPlanClass(
      this.patientPlan.mealPlan._id,
      this.patientPlan.mealPlan.name,
      this.patientPlan.mealPlan.instructions,
      this.patientPlan.mealPlan.tags,
      this.patientPlan.mealPlan.nutritionalProperties,
      await this.mealPlanService.getStructurePlanPeriods(this.patientPlan?.mealPlan),
      void 0,
      this.patientPlan.mealPlan.official
    );
    this.mealPlanClass.checkIfMealPlanHasAnyAllergicIngredient();
    this.mealPlanClass.checkIfMealPlanHasAnyDislikeIngredient();
  }

  async optionMealPlanSelected(option: OptionsMealPlanEnum): Promise<void> {
    const { clinicId, patientId } = this.params;
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    await this.router.navigate(
      [
        'clinic', clinicId, 'patients', patientId, 'meal-plans'
      ], {
      queryParams: { appointmentId: this.appointmentId, optionMealPlanFromUrl: option }
    });
  }

}
